module.exports = __webpack_public_path__ + "static/bg8-aebb6680d4792cf996b06e6d2e627e93.jpg";